<template>
  <div class="about-background-page">
    <v-container class="py-8">
      <v-row class="mb-6">
        <v-col cols="12">
          <h1 class="text-h3 font-weight-bold text-accent text-center mb-2">Onze gemeente</h1>
          <div class="text-center">
            <v-divider class="mb-4 mx-auto" width="100" thickness="3" color="primary"></v-divider>
          </div>
          <p class="text-body-1 text-center background-intro mx-auto">
            Op deze pagina lees je meer over wat wij geloven, waar onze gemeente vandaan komt en hoe
            wij verbonden zijn met de Nederlandse Gereformeerde Kerken.
          </p>
        </v-col>
      </v-row>

      <v-row class="mb-8">
        <v-col cols="12">
          <div class="content-column">
            <h2 class="text-h5 text-accent mb-2">Verbonden met de NGK</h2>
            <p class="text-body-1 background-copy">
              Onze gemeente maakt deel uit van de
              <a href="https://ngk.nl/" target="_blank" rel="noopener noreferrer">
                Nederlandse Gereformeerde Kerken
              </a>
              .
            </p>

            <h2 class="text-h5 text-accent mb-2">Wat wij geloven</h2>
            <p class="text-body-1 background-copy">
              Wij geloven dat God de aarde heeft gemaakt, en dat Hij onze Vader wil zijn. Wij
              geloven dat Hij zijn Zoon Jezus Christus naar de aarde heeft gestuurd om de mensen te
              redden. Hij stierf aan een kruis, maar stond op de eerste Paasmorgen op uit de dood!
              Hij versloeg de dood en de zonde (het kwaad). Er is nu hoop, genezing en vergeving
              voor iedereen die in Hem gelooft. Om daarbij te helpen kreeg de kerk met Pinksteren
              Gods Heilige Geest.
            </p>

            <h2 class="text-h5 text-accent mb-2">Onze traditie</h2>
            <p class="text-body-1 background-copy">
              Onze gemeente komt voort uit de Gereformeerde Kerken (vrijgemaakt). We geloven dat de
              Bijbel Gods Woord is, en we willen Jezus navolgen als Koning van ons leven. Hij heeft
              ons gekocht en betaald.
            </p>
            <p class="text-body-1 background-copy">
              We staan in de gereformeerde traditie. We onderschrijven deze drie
              belijdenisgeschriften uit de vroege kerk: de Apostolische Geloofsbelijdenis, de
              geloofsbelijdenis van Nicea en de geloofsbelijdenis van Athanasius. Deze belijdenissen
              delen we wereldwijd met vele kerken. Ook onderschrijven we drie gereformeerde
              geloofsbelijdenissen uit de tijd van de Reformatie: de Nederlandse Geloofsbelijdenis
              (1561), de Heidelbergse Catechismus (1563) en de Dordtse Leerregels (1618-1619).
            </p>

            <h2 class="text-h5 text-accent mb-2">Onze geschiedenis</h2>
            <p class="text-body-1 background-copy mb-0">
              In 2001 verscheen ter gelegenheid van het 60 jaar bestaan van onze gemeente een boek
              over de geschiedenis van onze gemeente:
              <em>Eemdijkers apart. Geschiedenis van de Gereformeerde Kerk te Eemdijk</em>. De
              schrijver hiervan is Willem Ruizendaal.
            </p>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <div class="d-flex justify-center">
            <v-btn
              color="highlight"
              variant="outlined"
              prepend-icon="mdi-arrow-left"
              to="/over-ons"
            >
              Terug naar Over ons
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style scoped>
.content-column {
  max-width: 820px;
  margin: 0 auto;
}

.background-intro {
  max-width: 760px;
}

.background-copy {
  margin-bottom: 1rem;
  line-height: 1.75;
}
</style>
